import { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { Text } from '@reveni-io/reveni-ui'

import CustomerDetailInfo from '@/common/components/CustomerDetailInfo/CustomerDetailInfo'
import RMAContext from '@/returns/pages/TransactionRMAPage/context/RMAContext'

const CustomerDetails = () => {
  const { rmaInfo } = useContext(RMAContext)
  const { t } = useTranslation()

  return (
    <>
      <Text type="titleS">{t('Datos del cliente')}</Text>
      <CustomerDetailInfo
        customerProfile={{
          ...rmaInfo?.orderInfo?.customer_profile,
          email: rmaInfo?.orderInfo?.customer_profile?.email?.email,
        }}
      />
    </>
  )
}

export default CustomerDetails
